import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { msalInstance } from '../../index';
import { getAzureAdClientId, getTicketsApiBaseUrl } from '../../utils/runtimeConfig';

const apiScope = `${getAzureAdClientId()}/InternalApi`;
const apiBaseUrl = getTicketsApiBaseUrl();

/**
 * Compliance API shell — endpoints are injected from complianceQueries.ts and
 * complianceMutations.ts. Mirrors assetApiBase.ts exactly.
 */
export const complianceApi = createApi({
  reducerPath: 'complianceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiBaseUrl,
    prepareHeaders: async (headers) => {
      try {
        const account = msalInstance.getActiveAccount();
        if (account) {
          const response = await msalInstance.acquireTokenSilent({
            account,
            scopes: [apiScope],
          });
          headers.set('Authorization', `Bearer ${response.accessToken}`);
        }
      } catch (e) {
        console.error('Failed to acquire token for Compliance API:', e);
      }
      return headers;
    },
  }),
  tagTypes: ['Compliance', 'ComplianceList', 'ComplianceDocument'],
  endpoints: () => ({}),
});
